import { render, staticRenderFns } from "./EventDisplay.vue?vue&type=template&id=9121f18c&scoped=true&"
import script from "./EventDisplay.vue?vue&type=script&lang=js&"
export * from "./EventDisplay.vue?vue&type=script&lang=js&"
import style0 from "./EventDisplay.vue?vue&type=style&index=0&id=9121f18c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9121f18c",
  null
  
)

export default component.exports